export default {
  list: {
    headers: {
      id: "ID",
      name: "Name",
      slug: "Slug",
      firm: "Company",
      email: "Email",
      live_url: "Live URL",
      dp_group_name: "Group name",
      started_at: "Unlock date",
      title_private: "Title",
      question: "Question",
      homework_id: "Homework ID",
      type: "Type",
      description: "Description",
      dp_mural_name: "Board name",
      group_names: "Group",
      question_private: "Question private",
      stage: "Step",
    },
    downloadHomeworks: "Download homeworks ZIP",
    downloadHomeworksEmpty: "No homeworks to download",
    sections: "sections",
    groups: "groups",
    groupusers: "participants",
    modules: "modules",
    homeworks: "homeworks",
    assessment: "assessments",
    games: "RPG games",
    preworks: "preworks",
    livewidgets: "Online meetings",
    kickoffs: "Kickoffs",
    precertificates: "pre-certification",
    schedules: "module unlock dates",
    edit: "edit",
    templates: "board templates",
    reflections: "reflections",
    materials: "add material",
    materialslist: "materials list",
    assessmentmodule: "add assessment to module",
    assessmentlist: "assigned assessments list",
  },
  sections: {
    headers: {
      name: "Name",
    },
  },
  form: {
    labels: {
      name: "Name",
      slug: "Slug",
      description: "Description",
      order: "Order",
      tabs: "Tabs order",
      color: "Color",
      programid: "Program ID",
      sectionid: "Section ID",
      moduleid: "Module ID",
      stage: "Step",
      rpg_url: "RPG game URL",
      rpg_description: "RPG game description",
      type: "Type",
      design_type: "Design type",
      preworkid: "Path ID",
      live_url: "Meeting URL",
      start_date: "Start date",
      end_date: "End date",
      start_at: "Unlock date",
      duration: "Duration",
      group: "Group ID",
      max_group_users: "Maximum number of users in group",
      calendar_url: "Calendar link",
      position: "Position",
      unlock_before_days: "Days to unlock before",
      active: "Active",
      status: "Status",
      widget_status: "Widget status",
      is_expired: "Is expired",
      is_conference: "Is conference",
      subtitles_pl: "Subtitles PL (.vtt)",
      subtitles_en: "Subtitles EN (.vtt)",
      question: "Question",
      menu_name_pl: "Menu PL",
      menu_name_en: "Menu ENG",
      disabled_homeworks: "Block homework while waiting for live",
      disabled_tools: "Block tools while waiting for live",
      show_welcome_baner: "Show welcome banner",
      show_exams: "Show exams",
      navigation_expandable: "Expandable navigation",
      can_user_join: "User can join",
      muralid: "Board ID",
      mural: "Board",
      title_private: "Private title",
      title_public: "Public title",
      subtitle: "Subtitle",
      lead: "Lead",
      description_private: "Private description",
      description_public: "Public description",
      thanks_title: "Thanks title",
      thanks_description: "Thanks description",
      presentation_type: "Presentation type",
      is_presented: "Is presented",
      is_presented_by_categories: "Is presented by categories",
      is_presented_by_questions: "Is presented by questions",
      is_interpreted: "Is interpreted",
      is_identity_requirement: "Is identity requirement",
      identity_requirement_data: "Identity requirement data",
      has_uuids: "Has UUIDs",
      is_categorized: "Is categorized",
      is_random_questions: "Is random questions",
      is_active: "Is active",
      is_hidden: "Is hidden",
      is_archived: "Is archived",
      access_level: "Access level",
      tools_title: "Assessment title in Tools view",
      title: "Title",
      tools_description: "Description in Tools view",
      label: "Label",
      assessment_subtitle: "Assessment subtitle",
      hex_color: "Color",
      joinable_before_days: "User can join earlier (days)",
      active_from: "Active from",
      is_challenge: "Challenge",
      google_calendar_link: "Google Calendar link",
      outlook_calendar_link: "Outlook Calendar link",
      cover: "Cover",
      cover_description: "cover",
      font_color: "Change font to black",
      vertical_cover_web: "Vertical web cover",
      horizontal_cover_web: "Horizontal web cover",
      wide_vertical_cover_web: "Wide vertical web cover",
      vertical_cover_mobile: "Vertical mobile cover",
      long_vertical_cover_web: "Long vertical mobile cover",
      cover_banner_web: "Web banner cover",
      cover_banner_mobile: "Mobile banner cover"
    },
    buttons: {
      save: "Save program",
      send: "Add program",
      copy_program: "Copy program"
    },
    sections: {
      save: "Save section",
      send: "Add section",
    },
    modules: {
      save: "Save module",
      send: "Add module",
    },
    groups: {
      save: "Save user",
      send: "Add user",
    },
    homeworks: {
      send: "Add homework",
      save: "Save homework",
    },
    assessmentModule: {
      send: "Add",
      save: "Save",
    },
    preworks: {
      send: "Add prework",
    },
    assessment: {
      send: "Add",
      save: "Save",
    },
    group: {
      save: "Save group",
      send: "Add group",
    },
    widgets: {
      save: "Save meeting",
      send: "Add meeting",
    },
    precertificates: {
      save: "Save",
      send: "Add",
    },
    reflections: {
      save: "Save reflection",
      send: "Add reflection",
    },
    murals: {
      save: "Save board template",
      send: "Add board template",
    },
  },
  types: {
    program: "Program",
    path: "CSR",
  },
  copy_modal: {
    title: "Copy program",
    select_program: "Select a program to copy",
    program: "Program",
    form_populated: "Form has been populated with program data. Make any changes and click Save to create the copy.",
    cancel_button: "Cancel",
    copy_button: "Copy"
  },
  modules_selection: {
    select_all: "Select all",
    deselect_all: "Deselect all",
    no_sections: "No sections found",
    no_modules: "No modules found"
  },
  copy_success: {
    title: "Copy Success",
    message: "Program copied successfully"
  },
  copy_error: {
    title: "Copy Error",
    message: "Error occurred while copying program"
  },
  copy_progress: {
    title: "Copying Program",
    message: "Please wait while the program is being copied..."
  },
  create: {
    title: "Create Program"
  },
  edit: {
    title: "Edit Program"
  },
  save_success: {
    title: "Save Success",
    message: "Program saved successfully"
  },
  save_error: {
    title: "Save Error",
    message: "Error occurred while saving program"
  },
}; 